import { logs } from "../logs.js";
import { parsers } from "./parsers.js";

class LogsParser {
  constructor() {
    parsers.addType("logs", this._applyLogs.bind(this));
  }

  _applyLogs(logArray) {
    // Direct logs usage: Parser configuration methods.
    // activateLogs() and initializeFilters() are part of the public logging configuration API,
    // used to set up the logging system based on application config. These are setup methods,
    // not component logging.
    logs.activateLogs();
    if (logArray.length > 0) {
      // Convert the logArray to a comma-separated string of namespaces
      const logFilters = logArray.join(',');
      logs.initializeFilters(logFilters);
      console.log(`Initialized logging system with filters: ${logFilters}`);
    } else {
      // If no logs are configured, set to "none" to disable all logging
      logs.initializeFilters("none");
      console.log("Disabled logging system (no logs configured)");
    }
  }
}

const logsParser = new LogsParser();
export { LogsParser, logsParser };
